import { de, } from './de.js';
export function translation(lang) {
    return {
        de,
    }[lang] ?? de;
}
//# sourceMappingURL=translation.js.map